import React, { Fragment, useState, useEffect } from "react";
import { APP_PATHS, getPostLoginPath } from '../utils/appPaths.js';
import { Form, FormGroup, Input, Label } from "reactstrap";
import { Image } from "../AbstractElements";
import {
  EmailAddress,
  Password,
  RememberPassword,
  SignIn,
} from "../Constant";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../_helper/Auth/AuthProvider";
import logoWhite from "../assets/images/logo/logo-white.png";
import TailChase from "../Components/Loaders/TailChase";
import { toUserMessage } from "../utils/apiErrorMessage";

const Signin = ({ selected, logoClassMain }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { authenticated, login } = useAuth();
  const [togglePassword, setTogglePassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const loginAuth = async (e) => {
    e.preventDefault();
    const trimmedEmail = email.trim();
    if (!trimmedEmail || !password) {
      toast.error("Please enter your email and password.");
      return;
    }

    setLoading(true);
    try {
      const { success, message } = await login(trimmedEmail, password);
      if (success) {
        toast.success(toUserMessage(message, "OTP sent. Please verify your login."));
        navigate(APP_PATHS.loginOtp(trimmedEmail), { state: location.state });
      } else {
        toast.error(
          toUserMessage(message, "Login failed. Please check your credentials.")
        );
      }
    } catch (error) {
      toast.error(
        toUserMessage(error, "Login failed. Please check your credentials.")
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (authenticated) {
      navigate(getPostLoginPath(location), { replace: true });
    }
  }, [authenticated, navigate, location]);

  return (
    <Fragment>
      <div className="login-card login-card--mono">
        <div>
          <div>
            <Link
              className={`logo ${logoClassMain ? logoClassMain : ""}`}
              to={APP_PATHS.login}
            >
              <Image
                attrImage={{
                  className: "img-fluid for-light login-logo-white",
                  src: logoWhite,
                  alt: "reddiamond.",
                }}
              />
            </Link>
          </div>
          <div className="login-main">
            <Form className="theme-form" onSubmit={loginAuth}>
              <FormGroup>
                <Label className="col-form-label">{EmailAddress}</Label>
                <Input
                  className="form-control"
                  type="email"
                  autoComplete="username"
                  placeholder="Email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
              </FormGroup>
              <FormGroup className="position-relative">
                <Label className="col-form-label">{Password}</Label>
                <div className="position-relative">
                  <Input
                    className="form-control"
                    type={togglePassword ? "text" : "password"}
                    autoComplete="current-password"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                  />
                  <div
                    className="show-hide"
                    onClick={() => setTogglePassword(!togglePassword)}
                  >
                    <span className={togglePassword ? "" : "show"}></span>
                  </div>
                </div>
              </FormGroup>
              <div className="position-relative form-group mb-0">
                <div className="checkbox">
                  <Input id="checkbox1" type="checkbox" />
                  <Label className="text-muted" for="checkbox1">
                    {RememberPassword}
                  </Label>
                </div>
                <Link to={APP_PATHS.forgetPwd} className="link">
                  Forgot Password
                </Link>
                <button
                  type="submit"
                  className={`btn btn-login-mono d-block w-100 mt-2 ${
                    loading ? "disabled" : ""
                  }`}
                  disabled={loading}
                >
                  {loading ? <TailChase /> : SignIn}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={4500} newestOnTop />
    </Fragment>
  );
};

export default Signin;
